import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { URLSearchParams } from '@angular/http';

import { Api } from './api.service';
import { PAGINATION_NUMBER } from './constants.service';
import { ListInterface } from './crud.interface';
import { Task, ListResult } from '../entities/index';
import { Log } from '../utils/index';

@Injectable()
export class TaskService implements ListInterface<Task> {

  constructor(protected http: Api) {
  }

  @Log('green')
  list(search: string = null, page: number = 1, limit: number = PAGINATION_NUMBER): Observable<ListResult<Task>> {
    const params = new URLSearchParams();
    if (search) {
      params.set('search', search);
    }
    if (page) {
      params.set('page', String(page));
    }
    if (limit) {
      params.set('limit', String(limit));
    }
    params.set('sort_field', 'created_at');
    params.set('sort_order', 'desc');

    return this.http.get('task', {search: params});
  }

  @Log('green')
  get(id: number): Observable<Task> {
    return this.http.get(`task/${id}`);
  }

  _taskFile(id: number, type: string): Observable<string> {
    return this.http
      .get(`task/${id}/${type}`)
      .map((res: any) => {
        return URL.createObjectURL(new Blob([res], {type: 'octet/stream'}));
      });
  }

  @Log('green')
  taskImportReport(id: number): Observable<string> {
    return this._taskFile(id, 'result');
  }

  @Log('green')
  taskImportFile(id: number): Observable<string> {
    return this._taskFile(id, 'file');
  }

  @Log('green')
  firmwareOtaCsv(file: File): Observable<number> {
    return this.http.makeFileRequest('task/firmware', file).map((res: Task) => res.id);
  }
}



// WEBPACK FOOTER //
// /builds/weenect1/backofficev3/src/app/services/task.service.ts